import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Grid,
  TextField,
  Typography,
  Button,
  CircularProgress,
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
} from "@material-ui/core";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import { selectImageToken } from "../../../features/userSlice";
import { openWebSite } from "../../../apis/util";
import { postRequest } from "../../../apis/axiosAction";
import {
  getOneVisionData,
  ONE_VISION_BIG_RECORD,
  ONE_VISION_OTHER_DATA,
  ONE_VISION_TOTAL_SCORE,
} from "./OneVisionDataOperation";
import { DateTime } from "luxon";
import {
  getFixedFlg,
  setFixedFlg,
  setInitTenpoCode,
} from "../../Header/Header";
import { makeStyles } from "@material-ui/core/styles";
import { setLastOneVisionId, setOneVisionId } from "./OneVision";
import { userLogging } from "../../../apis/userLog";
import OneVisionDialog from "../OneVisionDialog";
import {
  EXISTING_SEJ_STORES_RECORD,
  getAllExistingSejStores,
} from "../../../data/existingSejStores";
import { roundScore } from "./OneVisionCalculation";
import OneVisionResultGraphs2 from "./OneVisionResultGraphs2";

const useStyles = makeStyles({
  card: {
    margin: 3,
  },
  button: {
    color: "#fff",
    backgroundColor: "#ef942a",
    fontSize: "20px",
    width: "40vw",
    height: "5vh",
    margin: "10px",
    "&:hover": {
      background: "#ef942a",
    },
  },
  contentFrame: {
    overflowY: "auto",
    height: "68vh",
    // iPad縦
    "@media (min-width: 830px)": {
      height: "78vh",
    },
    // iPad横
    "@media (min-width: 1100px)": {
      height: "72vh",
    },
    // GWPC
    "@media (min-width: 1300px)": {
      height: "67vh",
    },
  },
  tableBodyCell: {
    padding: "0",
    verticalAlign: "top",
  },
  topSectionTitle: {
    writingMode: "vertical-rl",
    width: "5px",
    paddingTop: "0",
    paddingBottom: "0",
    border: "1px solid #aaa",
    backgroundColor: "whitesmoke",
  },
  tableItemCell: {
    padding: "0",
    border: "1px solid #aaa",
    borderTop: "hidden",
  },

  noCell: {
    paddingTop: "0",
    paddingBottom: "0",
    border: "1px solid #aaa",
    width: "17px",
    minWidth: "17px",
    backgroundColor: "whitesmoke",
  },
  itemCell: {
    padding: "0",
    paddingRight: "5px",
    paddingLeft: "5px",
    width: "100%",
    minWidth: "30vw",
    borderTop: "1px solid #aaa",
  },
  itemCell2: { padding: "0", width: "100vw" },
  okCell: {
    border: "1px solid #aaa",
    paddingTop: "0",
    paddingBottom: "0",
    textAlign: "center",
  },
  pointCell: {
    border: "1px solid #aaa",
    paddingTop: "0",
    paddingBottom: "0",
    textAlign: "center",
    minWidth: "30px",
  },
  minTableCell: {
    paddingTop: "0",
    paddingBottom: "0",
    border: "1px solid #aaa",
    whiteSpace: "nowrap",
  },
  right: {
    textAlign: "right",
  },
  empCell: {
    padding: "0",
    border: "none",
  },
  overLayer: {
    position: "fixed",
    width: "100%",
    height: "100%",
    top: "0",
    left: "0",
    backgroundColor: "#CCC",
    opacity: "0.5",
    zIndex: 100000,
  },
  circularProgress: {
    position: "absolute",
    top: "35%",
    left: "45%",
    opacity: "0.8",
    color: "#ccc",
  },
});

let pdfUrl = "";
let pdfFlg = false;
export { pdfFlg };
let updateFlg = 0;

const buttonNamePrint = "印刷（PDFダウンロード）";
const buttonNameExcute = "登録（PDF作成）";

function setScoreName(workMap: any) {
  let scorePatternList: any[] = workMap["score_pattern"];
  for (let i = 0; i < scorePatternList.length; i++) {
    if (scorePatternList[i].value === String(workMap["score"])) {
      workMap["score_name"] = scorePatternList[i].name;
    }
  }
}

// 曜日の取得
const getDayOfWeekText = (datetime: DateTime | null) => {
  if (!datetime) {
    return;
  }
  let weekDayArray: string[] = [];
  weekDayArray = ["月", "火", "水", "木", "金", "土", "日"];
  const dayOfWeek = datetime.weekday;
  return weekDayArray[dayOfWeek - 1];
};

const OneVisionResultPrint: React.FC<{
  tenpoCode: string;
  oneVisionId: string;
  lastOneVisionId: string;
  setUpdateFlg: any;
}> = ({ tenpoCode, oneVisionId, lastOneVisionId, setUpdateFlg }) => {
  const classes = useStyles();

  const [otherData, setOtherData] = React.useState<ONE_VISION_OTHER_DATA>({});
  const [totalScore, setTotalScore] = React.useState("");
  const [pdfButtonName, setPdfButtonName] = React.useState(
    pdfUrl ? buttonNamePrint : buttonNameExcute
  );
  const [rowItemList, setRowItemList] = React.useState<ONE_VISION_BIG_RECORD[]>(
    []
  );
  const [scoreItemList, setScoreItemList] = React.useState<
    ONE_VISION_TOTAL_SCORE[]
  >([]);

  const [middleScoreItemList, setMiddleScoreItemList] = React.useState<any[]>(
    []
  );
  const [approvalDate, setApprovalDate] = React.useState<DateTime | null>(
    DateTime.local()
  );
  const [convertedApprovalDate, setConvertedApprovalDate] = React.useState<
    string | null
  >(null);
  const [pdfURL, setPdfURL] = React.useState("");
  const [convertAgreementDate, setConvertAgreementDate] = React.useState("");
  const [convertRegulationDate, setConvertRegulationDate] = React.useState("");
  const storeMaster: Map<String, EXISTING_SEJ_STORES_RECORD> =
    getAllExistingSejStores().store_data;
  // 店舗レコードを内部データから取得
  const storeRecord = storeMaster.get(tenpoCode);
  const tenpoName = storeRecord ? storeRecord.tenpo_name : "";
  const [click, setClick] = React.useState(false);
  const [creatWait, setCreatWait] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [dialogMessage, setDialogMessage] = React.useState<any[]>([]);
  const [alertFlg, setAlertFlg] = React.useState(false);
  const [dialogFlg, setDialogFlg] = React.useState(false);
  const [dialogNum, setDialogNum] = React.useState(0);

  // ダイアログ表示
  const dialogCancel = () => {
    if (dialogNum === 2) {
      setPdfButtonName(buttonNameExcute);
      setCreatWait(false);
      handleClick();
      setLoading(false);
    }
    setDialogFlg(false);
  };
  const dialogOK = () => {
    if (!alertFlg) {
      if (dialogNum === 1) {
        setPdfButtonName("PDF作成中…");
        setCreatWait(true);
        handlePdfPrint();
      } else if (dialogNum === 2) {
        updatePdfPrint();
      }
    }
    setDialogFlg(false);
  };

  const handleClick = () => {
    setClick((prev) => !click);
  };

  const imageToken = useSelector(selectImageToken);

  function getPdfURL() {
    const dir_pdf: string = process.env.REACT_APP_GCS_DIR_PDF
      ? process.env.REACT_APP_GCS_DIR_PDF + "/"
      : "pdftest/";
    return (
      process.env.REACT_APP_CLOUD_STORAGE_URL +
      dir_pdf +
      oneVisionId +
      ".pdf" +
      "?access_token=" +
      imageToken
    );
  }

  useEffect(() => {
    if (!getFixedFlg()) {
      setPdfURL("");
      setPdfButtonName(buttonNameExcute);
    }
  }, [tenpoCode]);

  useEffect(() => {
    setLoading(true);
    userLogging("OneVision", "印刷#初期表示", oneVisionId);
    setApprovalDate(null);
    setConvertedApprovalDate("");
    getOneVisionData(tenpoCode, oneVisionId, lastOneVisionId).then(
      (res: any) => {
        setApprovalDate(
          res.approve_day
            ? DateTime.fromFormat(res.approve_day, "yyyyMMdd")
            : null
        );
        setConvertedApprovalDate(res.approve_day);
        setConvertAgreementDate(
          DateTime.fromFormat(res.agreement_day, "yyyyMMdd").toFormat(
            "yyyy年MM月dd日"
          )
        );
        setConvertRegulationDate(
          DateTime.fromFormat(res.regulation_day, "yyyyMMdd").toFormat(
            "yyyy年MM月dd日"
          )
        );

        let resRows: any[] = res.rows;
        //通しNo追加
        let no = 1;
        for (let i = 0; i < resRows.length; i++) {
          for (let j = 0; j < resRows[i]["rows"].length; j++) {
            resRows[i]["rows"][j]["id"] = no;
            if (resRows[i]["rows"][j]["score_pattern"].length === 2) {
              setScoreName(resRows[i]["rows"][j]);
            }
            no++;
          }
        }
        setRowItemList(resRows);
        setOtherData(res.other_data);
        setScoreItemList(res.score_data.scores);
        setTotalScore(res.score_data.total_score);
        setMiddleScoreItemList(res.score_data.middle_score);

        let scoreList: any[] = res.score_data.scores;
        let graphData: any[] = [];
        for (let i = 0; i < scoreList.length; i++) {
          if (Number(scoreList[i].no) && Number(scoreList[i].no) !== 0) {
            graphData.push({
              name: scoreList[i].name,
              点数: roundScore(scoreList[i].score),
            });
          }
        }

        if (getFixedFlg()) {
          setPdfURL(getPdfURL());
          setPdfButtonName(buttonNamePrint);
        }
        setLoading(false);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oneVisionId]);

  const history = useHistory();
  function clickReference(
    tenpoCode: string,
    oneVisionId: string,
    lastOneVisionId: string
  ) {
    setFixedFlg(true);
    setLastOneVisionId(lastOneVisionId);
    setOneVisionId(oneVisionId);
    setInitTenpoCode(tenpoCode);
    // 画面遷移
    history.push("one-vision");
  }

  function clickPdfPrint() {
    if (creatWait) {
      return;
    }
    if (pdfURL) {
      openWebSite(getPdfURL());
      return;
    }
    if (!checkInputOneVision()) {
      setAlertFlg(true);
      setDialogMessage([
        "未入力項目があります。",
        "入力内容を確認してください",
      ]);
      setDialogFlg(true);
      return;
    }
    let resultCkManHourDate = checkManHourDate();
    if (!resultCkManHourDate.result) {
      let message = ["入力内容に誤りがあります。", "以下を確認してください"];
      resultCkManHourDate.message.forEach(function (str) {
        message.push(String(str));
      });
      setAlertFlg(true);
      setDialogMessage(message);
      setDialogFlg(true);
      return;
    }
    if (!convertedApprovalDate) {
      setAlertFlg(true);
      setDialogMessage(["作成日を入力してください"]);
      setDialogFlg(true);
      return;
    }

    if (getFixedFlg()) {
      setPdfButtonName("PDF作成中…");
      setCreatWait(true);
      handlePdfPrint();
    } else {
      setAlertFlg(false);
      setDialogNum(1);
      setDialogMessage([
        "作成日 " +
          (approvalDate ? approvalDate.toFormat("yyyy年MM月dd日") : "") +
          " でPDF作成します。",
        "PDFの出力後に編集は行えません。",
        "よろしいですか？",
      ]);
      setDialogFlg(true);
      return;
    }
  }

  function checkInputOneVision() {
    let result = true;
    for (let i = 0; i < rowItemList.length; i++) {
      for (let j = 0; j < rowItemList[i].rows.length; j++) {
        if (!rowItemList[i].rows[j].score) {
          result = false;
        }
      }
    }
    return result;
  }
  function checkManHourDate() {
    let result = true;
    let message: String[] = [];
    if (
      (otherData.necessary_man_hour_week || 0) < 126 ||
      (otherData.necessary_man_hour_week || 0) > 630
    ) {
      message.push("・必要人時／週");
      result = false;
    }
    if (
      (otherData.necessary_man_hour_week || 0) <
      (otherData.shortage_man_hour_week || 0)
    ) {
      message.push("・不足人時／週");
      result = false;
    }
    if (!convertAgreementDate) {
      message.push("・三六協定");
      result = false;
    }
    if (!convertRegulationDate) {
      message.push("・就業規則");
      result = false;
    }
    return { result, message };
  }

  // 入力値比較
  const checkLatestRecord = (base: any[], check: any[]) => {
    for (let i = 0; i < base.length; i++) {
      if (base[i].rows.length !== check[i].rows.length) {
        return false;
      }
      for (let j = 0; j < base[i].rows.length; j++) {
        let baseRow = base[i].rows[j];
        let checkRow = check[i].rows[j];
        if (
          baseRow.big_item_id !== checkRow.big_item_id ||
          baseRow.small_item_id !== checkRow.small_item_id ||
          baseRow.score !== checkRow.score
        ) {
          return false;
        }
      }
    }
    return true;
  };

  const checkLatestData = (base: any, check: any) => {
    if (
      base.employee !== check.employee ||
      base.last_employee !== check.last_employee ||
      base.last_necessary_man_hour_date !==
        check.last_necessary_man_hour_date ||
      base.last_necessary_man_hour_week !==
        check.last_necessary_man_hour_week ||
      base.last_recruit !== check.last_recruit ||
      base.last_retire !== check.last_retire ||
      base.last_shortage_man_hour_date !== check.last_shortage_man_hour_date ||
      base.last_shortage_man_hour_week !== check.last_shortage_man_hour_week ||
      base.measures !== check.measures ||
      base.necessary_man_hour_date !== check.necessary_man_hour_date ||
      base.necessary_man_hour_week !== check.necessary_man_hour_week ||
      base.recruit !== check.recruit ||
      base.retire !== check.retire ||
      base.shortage_man_hour_date !== check.shortage_man_hour_date ||
      base.shortage_man_hour_week !== check.shortage_man_hour_week ||
      base.task !== check.task
    ) {
      return false;
    }
    return true;
  };

  const handlePdfPrint = async () => {
    setLoading(true);

    // 次回のOneVisionのデータを作成
    await getOneVisionData(tenpoCode, oneVisionId, lastOneVisionId).then(
      (res: any) => {
        let ckRowItemList = res.rows;
        let ckOtherData = res.other_data;

        // 画面の最新状態との比較
        if (
          convertedApprovalDate !== res.approve_day ||
          !checkLatestRecord(rowItemList, ckRowItemList) ||
          !checkLatestData(otherData, ckOtherData)
        ) {
          setPdfButtonName(buttonNameExcute);
          setCreatWait(false);
          handleClick();
          setLoading(false);
          setAlertFlg(true);
          setDialogNum(3);
          setDialogMessage([
            "他の画面から内容が変更されています。",
            "一度画面を閉じてから再度、当該店舗の情報を開いて",
            "内容を確認の上、提出してください。",
          ]);
          setDialogFlg(true);
          return;
        } else {
          const apiParams = {
            id: oneVisionId,
            approve_day: convertedApprovalDate,
            newFlag: true,
          };

          const url =
            process.env.REACT_APP_API_URL_J11SPB22 + "onevision/data-phase2";
          setCreatWait(true);
          postRequest(url, apiParams)
            .then(async (res) => {
              // 同一店舗同一週有りの場合、上書きの確認メッセージ表示
              if (res.data.dataList[0] === "SameStoreSameMonth") {
                if (getFixedFlg()) {
                  updatePdfPrint();
                  // 処理を終了する
                  return;
                } else {
                  setLoading(false);
                  setCreatWait(false);
                  setAlertFlg(false);
                  setDialogNum(2);
                  setDialogMessage(["上書き保存されますがよろしいですか？"]);
                  setDialogFlg(true);
                  // 処理を終了する
                  return;
                }
              }
              // 完了済みのレコードの場合
              else if (res.data.dataList[0] === "AlreadyCompleted") {
                setPdfButtonName(buttonNameExcute);
                setCreatWait(false);
                handleClick();
                setLoading(false);
                setAlertFlg(true);
                setDialogNum(3);
                setDialogMessage([
                  "既に登録されています。",
                  "新たにデータ登録する場合は左上のメニューから「新規作成」を、",
                  "作成されたデータを見る場合は左上のメニューからデータ検索してください。",
                ]);
                setDialogFlg(true);
                return;
              }
              // Firestoreへの入力内容に不備がある場合
              else if (res.data.dataList[0] === "InvalidFirestoreSave") {
                setPdfButtonName(buttonNameExcute);
                setCreatWait(false);
                handleClick();
                setLoading(false);
                setAlertFlg(true);
                setDialogNum(3);
                setDialogMessage([
                  "入力内容が正常に保存できませんでした。",
                  "メニューより「新規作成」を開き、対象店舗を選択して再度登録を実施してください。",
                ]);
                setDialogFlg(true);
                return;
              }
              const obj = JSON.parse(res.data.dataList[0]);
              setPdfURL(obj["url"]);
              setPdfButtonName(buttonNamePrint);
              setCreatWait(false);
              handleClick();
              setLoading(false);
              updateFlg++;
              setUpdateFlg(updateFlg);
              clickReference(tenpoCode, oneVisionId, lastOneVisionId);
            })
            .catch((r) => {
              setCreatWait(false);
              setLoading(false);
              setAlertFlg(true);
              setDialogMessage([String(r)]);
              setDialogFlg(true);
            });
        }
      }
    );
  };

  const updatePdfPrint = async () => {
    setLoading(true);
    setCreatWait(true);
    const url =
      process.env.REACT_APP_API_URL_J11SPB22 + "onevision/data-phase2";
    const apiParams2 = {
      id: oneVisionId,
      approve_day: convertedApprovalDate,
      newFlag: false,
    };
    await postRequest(url, apiParams2).then((res2) => {
      const obj = JSON.parse(res2.data.dataList[0]);
      setPdfURL(obj["url"]);
      setPdfButtonName(buttonNamePrint);
      setCreatWait(false);
      handleClick();
      setLoading(false);
      updateFlg++;
      setUpdateFlg(updateFlg);

      clickReference(tenpoCode, oneVisionId, lastOneVisionId);
    });
    // 処理を終了する
    return;
  };

  return (
    <>
      {loading && <div className={classes.overLayer}></div>}
      {loading && (
        <CircularProgress className={classes.circularProgress} size={120} />
      )}
      {rowItemList && rowItemList.length > 0 ? (
        <>
          <Grid container className={classes.contentFrame}>
            {/* 集計グラフ */}
            <Grid container justify="center">
              <OneVisionResultGraphs2
                tenpoCode={tenpoCode}
                oneVisionId={oneVisionId}
                lastOneVisionId={lastOneVisionId}
              />
            </Grid>
            {/* ヘッダー部↓ここから */}
            <Grid
              container
              justify="center"
              alignItems="center"
              style={{
                backgroundColor: "gray",
                height: "50px",
                color: "white",
              }}
              direction="row"
            >
              <Grid
                container
                justify="flex-start"
                direction="column"
                xs
                lg={3}
                md={3}
                sm={3}
              >
                <Typography variant="h5">One Vision</Typography>
              </Grid>
              <Grid
                container
                justify="center"
                direction="column"
                xs
                lg={5}
                md={5}
                sm={5}
              >
                <Typography variant="h5">{tenpoName}</Typography>
              </Grid>
              <Grid
                container
                justify="flex-end"
                direction="column"
                xs
                lg={3}
                md={3}
                sm={3}
              >
                <Typography variant="h5">
                  {approvalDate
                    ? approvalDate.toFormat("yyyy/MM/dd") +
                      "(" +
                      getDayOfWeekText(approvalDate) +
                      ")"
                    : ""}
                </Typography>
              </Grid>
            </Grid>
            {/* ヘッダー部↑ここまで */}
            {/* 表メイン↓ここから */}
            <Grid
              container
              justify="center"
              alignItems="center"
              direction="row"
            >
              <Table>
                {rowItemList.map((row) => (
                  <TableRow>
                    {String(row.big_item_id) !== "4" ? (
                      <TableCell className={classes.topSectionTitle}>
                        {row.big_title}
                      </TableCell>
                    ) : (
                      <TableCell className={classes.topSectionTitle}>
                        遵守項目　○
                        <span style={{ textCombineUpright: "all" }}>0</span>
                        点、×
                        <span style={{ textCombineUpright: "all" }}>-2</span>点
                      </TableCell>
                    )}
                    <TableCell className={classes.tableItemCell}>
                      {row.rows.map((rowData: any) => (
                        <>
                          <TableRow>
                            <TableCell className={classes.noCell}>
                              {rowData.id}
                            </TableCell>
                            <TableCell className={classes.itemCell}>
                              <TableRow>{rowData.small_title1}</TableRow>
                              {rowData.small_title2
                                ? "　　" + rowData.small_title2
                                : ""}
                            </TableCell>
                            {rowData.score_name !== "×" &&
                            rowData.score_name !== "◯" ? (
                              ""
                            ) : (
                              <TableCell className={classes.okCell}>
                                {rowData.score_name}
                              </TableCell>
                            )}
                            <TableCell className={classes.pointCell}>
                              {rowData.score || rowData.score === 0
                                ? rowData.score + "点"
                                : "―"}
                            </TableCell>
                          </TableRow>
                        </>
                      ))}
                    </TableCell>
                  </TableRow>
                ))}
              </Table>
            </Grid>
            {/* 表メイン↑ここまで */}

            <Grid style={{ padding: "10px" }}></Grid>

            {/* その他↓ここから */}
            <Grid container direction="row">
              {/* 各項目得点↓ここから */}
              <Grid
                container
                justify="center"
                alignItems="flex-start"
                direction="row"
              >
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  direction="column"
                  xs
                  lg={5}
                  md={8}
                  sm={8}
                >
                  <Table>
                    <TableHead
                      style={{
                        border: "1px solid #aaa",
                        backgroundColor: "whitesmoke",
                      }}
                    >
                      <TableCell colSpan={2} className={classes.minTableCell}>
                        各項目の小計
                      </TableCell>
                      <TableCell
                        className={classes.minTableCell}
                        style={{ textAlign: "center", minWidth: "40px" }}
                      >
                        点数
                      </TableCell>
                    </TableHead>
                    <TableBody>
                      {scoreItemList.map((row) => (
                        <>
                          <TableRow>
                            <TableCell
                              rowSpan={
                                row.no === "1"
                                  ? 4
                                  : row.no === "2"
                                  ? 4
                                  : row.no === "3"
                                  ? 3
                                  : 1
                              }
                              className={classes.minTableCell}
                            >
                              {row.no}
                            </TableCell>
                            <TableCell
                              className={classes.minTableCell}
                              style={{
                                backgroundColor: "whitesmoke",
                              }}
                            >
                              {row.name}{" "}
                            </TableCell>
                            <TableCell
                              className={
                                classes.minTableCell + " " + classes.right
                              }
                              style={{
                                backgroundColor: "whitesmoke",
                              }}
                            >
                              {roundScore(row.score)} / {row.max_score} 点
                            </TableCell>
                          </TableRow>

                          {middleScoreItemList
                            ? middleScoreItemList.map((middleRows) =>
                                row.no === middleRows.big_item_id ? (
                                  <TableRow>
                                    <TableCell className={classes.minTableCell}>
                                      {middleRows.name}{" "}
                                    </TableCell>
                                    <TableCell
                                      className={
                                        classes.minTableCell +
                                        " " +
                                        classes.right
                                      }
                                    >
                                      {roundScore(middleRows.score)} /{" "}
                                      {middleRows.max_score} 点
                                    </TableCell>
                                  </TableRow>
                                ) : (
                                  ""
                                )
                              )
                            : ""}
                        </>
                      ))}
                    </TableBody>
                  </Table>
                  <Grid style={{ padding: "3px" }}></Grid>
                </Grid>

                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  direction="column"
                  xs
                  lg={7}
                  md={10}
                  sm={10}
                  style={{ paddingLeft: "10px" }}
                >
                  <Grid container direction="row">
                    <Grid
                      container
                      justify="center"
                      alignItems="center"
                      direction="column"
                      xs
                      lg={4}
                      md={4}
                      sm={6}
                    >
                      <Table>
                        <TableRow
                          style={{
                            backgroundColor: "whitesmoke",
                          }}
                        >
                          <TableCell
                            className={classes.minTableCell}
                            style={{
                              textAlign: "center",
                            }}
                          >
                            必要人時
                          </TableCell>
                          <TableCell
                            className={classes.minTableCell}
                            style={{
                              textAlign: "center",
                            }}
                          >
                            不足人時
                          </TableCell>
                        </TableRow>
                        <TableBody>
                          <TableRow>
                            <TableCell
                              className={
                                classes.minTableCell + " " + classes.right
                              }
                            >
                              {otherData.necessary_man_hour_date}人時/日
                            </TableCell>
                            <TableCell
                              className={
                                classes.minTableCell + " " + classes.right
                              }
                            >
                              {otherData.shortage_man_hour_date} 人時/日
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell
                              className={
                                classes.minTableCell + " " + classes.right
                              }
                            >
                              {otherData.necessary_man_hour_week} 人時/週
                            </TableCell>
                            <TableCell
                              className={
                                classes.minTableCell + " " + classes.right
                              }
                            >
                              {otherData.shortage_man_hour_week} 人時/週
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Grid>
                    <Grid
                      container
                      justify="center"
                      alignItems="center"
                      direction="column"
                      xs
                      lg={4}
                      md={4}
                      sm={6}
                    >
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell
                              className={classes.minTableCell}
                              style={{
                                border: "1px solid #aaa",
                                backgroundColor: "whitesmoke",
                              }}
                            >
                              従業員人数（直近）
                            </TableCell>
                            <TableCell
                              className={classes.minTableCell}
                              style={{
                                verticalAlign: "bottom",
                              }}
                            >
                              {otherData.employee}人
                            </TableCell>
                          </TableRow>
                          <TableRow style={{ verticalAlign: "middle" }}>
                            <TableCell
                              className={classes.minTableCell}
                              style={{
                                border: "1px solid #aaa",
                                backgroundColor: "whitesmoke",
                                whiteSpace: "nowrap",
                                paddingRight: "0px",
                              }}
                            >
                              採用人数（一年間累計）
                            </TableCell>
                            <TableCell className={classes.minTableCell}>
                              {otherData.recruit} 人
                            </TableCell>
                          </TableRow>
                          <TableRow style={{ verticalAlign: "middle" }}>
                            <TableCell
                              className={classes.minTableCell}
                              style={{
                                border: "1px solid #aaa",
                                backgroundColor: "whitesmoke",
                                whiteSpace: "nowrap",
                                paddingRight: "0px",
                              }}
                            >
                              退職人数（一年間累計）
                            </TableCell>
                            <TableCell className={classes.minTableCell}>
                              {otherData.retire} 人{" "}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Grid>
                    <Grid
                      container
                      justify="center"
                      alignItems="center"
                      direction="column"
                      xs
                      lg={4}
                      md={4}
                      sm={12}
                    >
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell
                              colSpan={2}
                              className={classes.minTableCell}
                              style={{
                                border: "1px solid #aaa",
                                backgroundColor: "whitesmoke",
                              }}
                            >
                              三六協定・就業規則
                            </TableCell>
                          </TableRow>
                          <TableRow style={{ verticalAlign: "middle" }}>
                            <TableCell
                              className={classes.minTableCell}
                              style={{
                                border: "1px solid #aaa",
                                backgroundColor: "whitesmoke",
                              }}
                            >
                              三六協定
                            </TableCell>
                            <TableCell className={classes.minTableCell}>
                              {convertAgreementDate}
                            </TableCell>
                          </TableRow>
                          <TableRow style={{ verticalAlign: "middle" }}>
                            <TableCell
                              className={classes.minTableCell}
                              style={{
                                border: "1px solid #aaa",
                                backgroundColor: "whitesmoke",
                              }}
                            >
                              就業規則
                            </TableCell>
                            <TableCell className={classes.minTableCell}>
                              {convertRegulationDate}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Grid>
                  </Grid>
                  <Grid container direction="row">
                    <Table>
                      <TableCell
                        style={{
                          border: "1px solid #aaa",
                        }}
                      >
                        合計
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #aaa",
                          textAlign: "right",
                          fontSize: "20px",
                        }}
                      >
                        {totalScore}点
                      </TableCell>
                    </Table>
                  </Grid>

                  {/* グラフ・課題・対策↓ここから */}
                  <Grid container direction="row">
                    <Grid container>◆課題</Grid>
                    <Grid container>
                      <TextField
                        aria-label="store-input-comment-area"
                        multiline
                        rows={4}
                        variant="outlined"
                        value={otherData.task}
                        fullWidth={true}
                        inputProps={{ readOnly: true }}
                      ></TextField>
                    </Grid>
                    <Grid style={{ padding: "10px" }}></Grid>
                    <Grid container>◆対策</Grid>
                    <Grid container>
                      <TextField
                        aria-label="store-input-comment-area"
                        multiline
                        value={otherData.measures}
                        rows={4}
                        variant="outlined"
                        fullWidth={true}
                        inputProps={{ readOnly: true }}
                      ></TextField>
                    </Grid>
                  </Grid>
                  {/* グラフ・課題・対策↑ここまで */}
                </Grid>
              </Grid>
              {/* 各項目得点↑ここまで */}

              <Grid style={{ padding: "10px" }}></Grid>
            </Grid>
            {/* その他↑ここまで */}
          </Grid>
          {/* 印刷ボタン↓ここから */}
          <Grid container justify="center" alignItems="center">
            <Button
              variant="contained"
              className={classes.button}
              onClick={() => {
                userLogging("OneVision", "印刷#帳票出力", "");
                clickPdfPrint();
              }}
            >
              {pdfButtonName}
              {pdfURL ? <DownloadIcon /> : ""}
            </Button>
          </Grid>
          {/* 印刷ボタン↑ここまで */}
        </>
      ) : (
        ""
      )}

      <OneVisionDialog
        msg={dialogMessage}
        isOpen={dialogFlg}
        doOK={dialogOK}
        doNo={dialogCancel}
        isAlert={alertFlg}
      />
    </>
  );
};

export default OneVisionResultPrint;
